import React from 'react';

import { Link } from '@gogame/components';

const TextViewer = ({ text }) => {
  return text.split(/(\[.*?\])/).map(parseStringByLinks);
};

export default TextViewer;

function parseStringByLinks(string, i) {
  if (
    string.charAt(0) === '[' &&
    string.charAt(string.length - 1) === ']' &&
    string.includes('|')
  ) {
    const [, nameLink, hrefLink] = string.match(/\[(.+?)\|(.+?)\]/) || [];
    return (
      <Link key={i} href={hrefLink} target={'_blank'}>
        {nameLink}
      </Link>
    );
  }

  return <React.Fragment key={i}>{string}</React.Fragment>;
}
